module.exports = class ProductBrandsFormCtrl
  $onInit: ->
    @title = if @isNew then 'New Product Brand' else 'Edit Product Brand'

  submit: ->
    @onSubmit(productBrand: @productBrand)
